import React from "react";
import { Link } from "react-router-dom";
import { FaLink, FaExternalLinkAlt, FaDatabase, FaExchangeAlt } from "react-icons/fa";

const DEFAULT_CONNECTORS = [
  { name: "RENAPO (CURP & Identidad)", type: "REST API", status: "Conectado", latency: "140ms" },
  { name: "Catastro Municipal Querétaro", type: "PostgreSQL / GeoServer", status: "Conectado", latency: "42ms" },
  { name: "SERIE Finanzas del Estado", type: "SOAP / XML", status: "Conectado", latency: "190ms" },
  { name: "Servicio de Notificaciones SMTP", type: "SMTP / TLS", status: "Conectado", latency: "65ms" },
];

export default function InteropConnectorsSummary({ connectors = [], collapsible = false }) {
  const list = connectors && connectors.length > 0 ? connectors : DEFAULT_CONNECTORS;
  const Card = collapsible ? "details" : "div";
  const CardHeader = collapsible ? "summary" : "div";

  const manageLink = (
    <Link
      to="/interoperability"
      className="sad-card-badge"
      style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}
    >
      <span>Gestionar Hub</span>
      <FaExternalLinkAlt style={{ fontSize: "0.65rem" }} />
    </Link>
  );

  const connectorsContent = (
    <div className="sad-interop-list">
      {list.slice(0, 4).map((conn, idx) => (
        <div key={idx} className="sad-interop-item">
          <div className="sad-interop-info">
            <div className="sad-interop-icon">
              {conn.type?.includes("PostgreSQL") ? <FaDatabase /> : <FaExchangeAlt />}
            </div>
            <div>
              <div className="sad-interop-name">{conn.name || conn.serviceName}</div>
              <div className="sad-interop-type">{conn.type || conn.connectionType || "Conector Externo"}</div>
            </div>
          </div>

          <div style={{ textAlign: "right" }}>
            <span className={`sad-badge ${conn.status === "Conectado" || conn.status === "ONLINE" ? "success" : "danger"}`}>
              {conn.status || "En Línea"}
            </span>
            <div style={{ fontSize: "0.7rem", color: "#64748b", marginTop: "2px" }}>
              {conn.latency || "Operativo"}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <Card
      className={`sad-card${collapsible ? " sad-card-collapsible" : ""}`}
      open={collapsible ? true : undefined}
    >
      <CardHeader className="sad-card-header">
        <span className="sad-card-title">
          <FaLink className="text-primary" /> Matriz de Interoperabilidad
        </span>
        {!collapsible && manageLink}
      </CardHeader>
      {collapsible ? (
        <div className="sad-card-collapsible-body">
          <div className="sad-card-collapsible-actions">{manageLink}</div>
          {connectorsContent}
        </div>
      ) : connectorsContent}
    </Card>
  );
}
